package org.multiplatform.kotfolio.pages.koin

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.core.Page
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/koin/navigation")
@Composable
fun KoinNavigationPage() {
    BlogLayout(
        PageProperties(
            "Koin Navigation",
            ""
        ),
        BlogProperties("Koin", "Navigation")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            KotlinCode(
                code = """
                    //Theme.kt
                    private val DarkColorScheme = darkColorScheme(
                        primary = Purple80,
                        secondary = PurpleGrey80,
                        tertiary = Pink80
                    )

                    private val LightColorScheme = lightColorScheme(
                        primary = Purple40,
                        secondary = PurpleGrey40,
                        tertiary = Pink40

                        /* Other default colors to override
                        background = Color(0xFFFFFBFE),
                        surface = Color(0xFFFFFBFE),
                        onPrimary = Color.White,
                        onSecondary = Color.White,
                        onTertiary = Color.White,
                        onBackground = Color(0xFF1C1B1F),
                        onSurface = Color(0xFF1C1B1F),
                        */
                    )

                    @Composable
                    fun KoinNavigationTheme(
                        darkTheme: Boolean = isSystemInDarkTheme(),
                        // Dynamic color is available on Android 12+
                        dynamicColor: Boolean = true,
                        content: @Composable () -> Unit
                    ) {
                        val colorScheme = when {
                            dynamicColor && Build.VERSION.SDK_INT >= Build.VERSION_CODES.S -> {
                                val context = LocalContext.current
                                if (darkTheme) dynamicDarkColorScheme(context) else dynamicLightColorScheme(context)
                            }

                            darkTheme -> DarkColorScheme
                            else -> LightColorScheme
                        }

                        MaterialTheme(
                            colorScheme = colorScheme,
                            typography = Typography,
                            content = content
                        )
                    }
                    
                    //Route.kt
                    import kotlinx.serialization.Serializable
                    import androidx.navigation3.runtime.NavKey

                    @Serializable
                    sealed interface Route : NavKey {
                        @Serializable data object Home : Route
                        @Serializable data object CreatePost : Route
                    }
                    
                    //PostListScreen.kt
                    @OptIn(ExperimentalMaterial3Api::class)
                    @Composable
                    fun PostListScreen(
                        viewModel: PostViewModel,
                        onNavigateToCreate: () -> Unit
                    ) {
                    }
                    
                    @OptIn(ExperimentalMaterial3Api::class)
                    @Composable
                    fun CreatePostScreen(
                        viewModel: PostViewModel,
                        onBack: () -> Unit
                    ) {
                    }
                    
                    //NavigationModule.kt
                    import org.koin.androidx.compose.koinViewModel
                    import org.koin.core.annotation.KoinExperimentalAPI
                    import org.koin.dsl.module
                    import org.koin.dsl.navigation3.navigation

                    @OptIn(KoinExperimentalAPI::class)
                    fun NavigationModule(backStack: NavBackStack<NavKey>) = module {
                        navigation<Route.Home> {
                            PostListScreen(
                                viewModel = koinViewModel(),
                                onNavigateToCreate = { backStack.add(Route.CreatePost) }
                            )
                        }

                        navigation<Route.CreatePost> {
                            CreatePostScreen(
                                viewModel = koinViewModel(),
                                onBack = { backStack.removeLastOrNull() }
                            )
                        }
                    }
                    
                    //MainActivity.kt
                    class MainActivity : ComponentActivity() {
                        @OptIn(KoinExperimentalAPI::class)
                        override fun onCreate(savedInstanceState: Bundle?) {
                            super.onCreate(savedInstanceState)
                            enableEdgeToEdge()
                            setContent {
                                KoinNavigationTheme {
                                    val backStack = rememberNavBackStack(  Route.Home)

                                    BackHandler(enabled = backStack.size > 1) {
                                        backStack.removeLastOrNull()
                                    }
                                    loadKoinModules(NavigationModule(backStack))

                                    NavDisplay(
                                        backStack = backStack,
                                        onBack = { backStack.removeLastOrNull() },
                                        entryProvider =  koinEntryProvider(),
                                        entryDecorators = listOf(
                                            rememberSaveableStateHolderNavEntryDecorator(),
                                            rememberViewModelStoreNavEntryDecorator()
                                        )
                                    )
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )
        }
    }
}

//https://medium.com/@spparks_/koin-scaling-your-project-with-annotations-ksp-and-navigation-3-integration-273abe767a4b